




































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import ChangeDeliteButtons from "../../buttons/change-delite-buttons.vue";
import VueMarkdown from "vue-markdown";
import InputSearch from "../../app/search/input-search.vue";
import MainDemo from "@/components/demo/main-demo.vue";
import LanguagesButtons from "@/components/buttons/languages-buttons.vue";
import RouteCitysDemo from "../../demo/route_info/route-citys-demo.vue";

import { preferred_language } from "@/config/languags.config.json";
import { IRouteCity } from "@/@types/routeInfo/route-info";
import { deleteElement } from "@/api/delite/delite-element";
import { routeInfo } from "@/config/host.config";

@Component({
  components: {
    ChangeDeliteButtons,
    InputSearch,
    MainDemo,
    LanguagesButtons,
    RouteCitysDemo,
    VueMarkdown,
  },
})
export default class FullcityCityList extends Vue {
  @Prop({ type: Array, default: [] }) cityList!: Array<IRouteCity>;
  @Prop({ type: Boolean, default: false }) auto!: boolean;

  id = "";
  search = "";
  locale = preferred_language;

  get demoObject(): IRouteCity | null {
    const city = this.cityList.find((el) => el._id == this.id);
    if (city) return city;
    return null;
  }

  get citys(): Array<IRouteCity> {
    return this.cityList.filter((item) => {
      if (item.name && !Array.isArray(item.name))
        return (
          this.$getLocale(item.name)
            .toLowerCase()
            .indexOf(this.search.toLowerCase()) > -1
        );
      else return this.$getLocale(item.name);
    });
  }

  warnAlert(): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("alerts.emptyUpdate")),
      type: "warn",
    });
  }

  async changeElement(id: string, type: boolean): Promise<void> {
    if (type) {
      this.$router.push({ name: "AddRouteCity", params: { id: id } });
      return;
    }

    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("main.confirms.ok")),
        {
          title: String(this.$i18n.t("RouterInfo.CityList.confirm")),
        }
      );

      if (!result) return;
      const url = routeInfo.citys;
      deleteElement(id, url)
        .then(() => {
          this.$notify({
            group: "global",
            text: String(this.$i18n.t("error.200")),
          });
          this.$emit("deleteCity", id);
        })
        .catch(() => {
          this.warnAlert();
        });
    } catch {
      this.warnAlert();
    }
  }
}
